import { TextareaAutosize } from '@mui/material';
import { styled } from '@mui/material';
import { DARK_TEXT_COLOR } from '../../colors';

export const CustomTextArea = styled(TextareaAutosize)(`
  font-size: 1rem;
  outline: none;
  font-weight: 400;
  border-radius: 28.7px;
  background-color: #d4daea;
  border: none;
  padding: 18px 28px;
  color: ${DARK_TEXT_COLOR};
  transition: all 300ms ease;
  resize: vertical;
  '&::-webkit-scrollbar': {
    width: '0px',
    height: '0px'
    }
  &:hover {
  }

  &:focus {
    outline: none;
  }
`);
